import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';

// Subset of get_active_plan() we consume on the dashboard. The RPC derives the
// agency from auth.uid() when called with no argument.
export interface ActivePlan {
  agency_id?: string;
  role?: string;
  payment_status?: 'current' | 'grace' | 'suspended' | 'cancelled' | 'test' | 'unknown';
  days_until_cycle_end?: number;
  membership?: {
    package_id?: string;
    title?: string;
    tier?: 'standard' | 'pro' | 'cbr' | 'test' | string;
    cycle?: string;
    cycle_start?: string | null;
    cycle_end?: string | null;
    price?: number;
  };
  addons?: Array<{ category?: string; [k: string]: unknown }>;
  auto_pay?: { active?: boolean };
}

export function useActivePlan() {
  const [plan, setPlan] = useState<ActivePlan | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!supabase) { setLoading(false); return; }
    let cancelled = false;
    supabase.rpc('get_active_plan').then(({ data, error }) => {
      if (cancelled) return;
      if (!error && data) setPlan(data as ActivePlan);
      setLoading(false);
    });
    return () => { cancelled = true; };
  }, []);

  return { plan, loading };
}
